import React from "react";
import ReactDOM from "react-dom/client";
import WidgetContainer from "./WidgetContainer";
import Widget from "./Widget";

const isApp = process.env.IS_APP;
const container = document.getElementById("prelaunchlist-widget");

if (!container) {
  throw new Error("Container not found.");
}

const WidgetComponent = isApp ? WidgetContainer : Widget;

ReactDOM.createRoot(container).render(<WidgetComponent />);
